export default __webpack_public_path__ + "static/media/Slide12.1accbf32.PNG";